module.exports = __webpack_public_path__ + "static/img/medium_logo4.84b588e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/medium_logo4.png
// module id = HzjE
// module chunks = 11